import { Component } from 'react'
import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import { Theme } from 'Theme'

const onAction = (_node, _action) => {}
const onNodeToggle = _currentNode => {}

let menu = null

export class ReactTreeSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      row: props.row,
      data: props.data,
    }
  }

  componentDidMount() {
    this.setState({
      ...this.props.data,
    })
    menu = document.querySelectorAll('.dropdown-content')[0]

    if (!menu) {
      return
    }

    menu.addEventListener('wheel', function (e) {
      menu.scrollTop += e.deltaY
    })
  }

  onChange() {}

  handleClick(newNode, selectedItems) {
    this.props.updateData(selectedItems)
  }

  handleTabs(e) {
    if (e.keyCode == 9 || e.keyCode == 27) {
      // escape out of tabs
      e.stopPropagation()
      e.preventDefault()
      this.refs.selectRef && this.refs.selectRef.blur()
      this.props.close()
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (state) {
      return {
        data: JSON.parse(JSON.stringify(props.data)),
      }
    }
    // Return null if the state hasn't changed
    return null
  }

  render() {
    return (
      <Theme>
        <DropdownTreeSelect
          className="mdl-demo"
          data={this.state.data}
          onChange={this.handleClick.bind(this)}
          onAction={onAction}
          onNodeToggle={onNodeToggle}
          showDropdown="always"
          keepChildrenOnSearch={true}
          keepTreeOnSearch={true}
          texts={{ placeholder: 'Search' }}
          mode={this.props.multi ? 'multiSelect' : 'radioSelect'}
          radioSelect={this.props.multi}
          keepOpenOnSelect={true}
          hierarchical={true}
        />
      </Theme>
    )
  }
}
